(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-reviews"]) return;
  try {
    
  if (!customElements.get('ck-review-marquee')) {
    customElements.define('ck-review-marquee', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      init() {
        this.track = this.querySelector('.ck-review-track');
        if (!this.track) return;
        this.track.querySelectorAll('[data-clone]').forEach(card => card.remove());
        this.cards = Array.from(this.track.children);
        if (!this.cards.length) return;
        this.index = 0;
        this.paused = false;
        this.touching = false;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.measure();
        this.observer = new ResizeObserver(() => {
          if (this.clientWidth !== this.measuredWidth) this.measure();
        });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => this.start(), options);
        this.motion.addEventListener('change', () => this.start(), options);
        this.addEventListener('keydown', event => {
          if (event.target !== this) return;
          if (event.code === 'Space') {
            event.preventDefault();
            this.paused = !this.paused;
            this.start();
          } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.advance(event.key === 'ArrowRight' ? 1 : -1);
            this.start();
          }
        }, options);
        this.addEventListener('pointerdown', event => {
          this.pointerX = event.clientX;
          this.touching = true;
          this.start();
        }, options);
        document.addEventListener('pointerup', event => {
          if (!this.touching) return;
          this.touching = false;
          const distance = event.clientX - this.pointerX;
          if (Math.abs(distance) > 40) this.advance(distance < 0 ? 1 : -1);
          this.start();
        }, options);
        document.addEventListener('pointercancel', () => {
          this.touching = false;
          this.start();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.reviewId === event.detail.blockId);
          if (index < 0) return;
          clearTimeout(this.resetTimer);
          this.index = index;
          this.paint(false);
          this.start();
        }, options);
      }

      measure() {
        clearTimeout(this.resetTimer);
        this.track.querySelectorAll('[data-clone]').forEach(card => card.remove());
        this.measuredWidth = this.clientWidth;
        this.step = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        if (this.cards.length > 1 && this.step > 0) {
          const count = Math.ceil(this.clientWidth / this.step) + 1;
          for (let i = 0; i < count; i++) {
            const clone = this.cards[i % this.cards.length].cloneNode(true);
            clone.setAttribute('data-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('inert', '');
            clone.removeAttribute('data-shopify-editor-block');
            clone.removeAttribute('data-review-id');
            this.track.appendChild(clone);
          }
        }
        this.index %= this.cards.length;
        this.paint(false);
        this.start();
      }

      paint(animated) {
        this.track.style.transition = animated && !this.motion.matches ? 'transform 650ms ease-in-out' : 'none';
        this.track.style.transform = `translate3d(${-this.index * this.step}px, 0, 0)`;
      }

      advance(direction = 1) {
        if (this.cards.length < 2 || this.step <= 0) return;
        clearTimeout(this.resetTimer);
        this.index %= this.cards.length;
        this.paint(false);
        if (direction < 0 && this.index === 0) {
          this.index = this.cards.length;
          this.paint(false);
        }
        this.track.getBoundingClientRect();
        this.index += direction;
        this.paint(true);
        if (this.index === this.cards.length) {
          this.resetTimer = setTimeout(() => {
            this.index = 0;
            this.paint(false);
          }, this.motion.matches ? 0 : 700);
        }
      }

      start() {
        clearInterval(this.timer);
        if (!this.isConnected || this.cards.length < 2 || this.paused || this.touching ||
            document.hidden || this.motion.matches) return;
        this.timer = setInterval(() => this.advance(), 4000);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearInterval(this.timer);
        clearTimeout(this.resetTimer);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
